import VConsole from "vconsole";
export function debug(el) {
  if (process.env.VUE_APP_TITLE !== "production" && process.env.VUE_APP_TITLE !== "gray") {
    new VConsole()
    return
  }
  let i = 0;
  let timer = null;
  console.log("el", el);
  el.addEventListener("click", function() {
    i++;
    !timer &&
      (timer = setTimeout(() => {
        if (i >= 6) {
          newVc();
        } else {
          i = 0;
          timer = null;
        }
      }, 1000));
  });
}
function newVc() {
  var myPlugin = new VConsole.VConsolePlugin("physicianVc", "fileName");
  myPlugin.on("init", function() {
    console.log("My plugin init");
  });
  
  myPlugin.on("renderTab", function(callback) {
    let scripts = document.querySelectorAll("script");
  let links = document.querySelectorAll("link");
  // console.log('links+++++++++++++++++++++++',links)
  let fileNameOfJs;
  let fileNameOfCss;
  let chunkOfJs;
  let chunkOfCss;
  for (let i = 0; i < scripts.length; i++) {
    if(!scripts[i].src){
      continue
    }
    if (scripts[i].src.indexOf("app") > -1) {
      fileNameOfJs = scripts[i].src;
    }
    if (scripts[i].src.indexOf("chunk-vendors") > -1) {
      chunkOfJs = scripts[i].src;
    }
  }
  for (let i = 0; i < links.length; i++) {
    if(!links[i].href){
      continue
    }
    if (links[i].href.indexOf("app") > -1) {
      fileNameOfCss = links[i].href;
    }
    if (links[i].href.indexOf("chunk-vendors") > -1) {
      chunkOfCss = links[i].href;
    }
  }
    var html = `<div style="border-bottom:1px solid #efefef;padding:5px 20px;color:red;">${fileNameOfJs}</div>
    <div style="border-bottom:1px solid #efefef;padding:5px 20px;color:red;">${chunkOfJs}</div>
    <div style="border-bottom:1px solid #efefef;padding:5px 20px;color:#3572b0;">${fileNameOfCss}</div>
    <div style="border-bottom:1px solid #efefef;padding:5px 20px;color:#3572b0;">${chunkOfCss}</div>`;
    callback(html);
  });
  myPlugin.on("addTool", function(callback) {
    var button = {
      name: "Reload",
      onClick: function(event) {
        location.reload();
      },
    };
    callback([button]);
  });
  let vc = new VConsole();
  vc.addPlugin(myPlugin);
}
